








































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { namespace, Getter } from 'vuex-class';
import { Getters } from '@/stores/reports/getter-constants';
import { Forbidden } from '@/models/forbidden-error';
import { Mutations } from '@/stores/reports/mutation-constants';
import { DateTime } from 'luxon';
import { dateParse } from '@/date-picker-parser';
import loading from '@/components/loading.vue';
import { Permissions } from '@/models/permission-constants';
import { ActionConstants } from '@/stores/reports/action-constants';
import { ReportApi } from '@/api/report-api';
import deleteReport from '@/components/reports/delete-report-modal.vue';
import { ReportDetails } from '@/models/reports/report-details';
import VideoPlayerModal from '@/components/video-player/video-player-modal.vue';

const Module = namespace('report');
const reportApi = new ReportApi();

@Component({
    components: {
        loading,
        deleteReport,
        VideoPlayerModal,
    },
})

export default class ReportList extends Vue {
    @Module.Getter('allReportsTotalPages') public totalPages: number;
    @Module.Getter('allReportsPageSize') public currentPageSize: number;
    @Module.Getter('allReportsTotal') public totalReports: number;
    @Module.Getter('allReports') public reports: Array<ReportDetails>;
    @Module.Getter('allReportsPage') public currentPage: number;
    @Module.Getter('allReportsFilterStatus') public filterStatus: Array<ReportDetails>;
    @Module.Getter('allReportsFrom') public from: string | null;
    @Module.Getter('allReportsTo') public to: string | null;
    @Prop({ type: Number, default: 1 }) public page: number;
    @Prop({ type: Number, default: 1 }) public pageSize: number;
    @Prop({ type: Number, default: 1 }) public total: number;
    @Prop({ type: [Number, String] }) public status: number | string;
    @Prop({ type: Boolean, default: false }) public showCreator: boolean;
    @Prop({ type: Boolean, default: false }) public showActions: boolean;
    @Prop({ type: Boolean, default: true }) public isLoading: boolean;
    public selectedReport: ReportDetails | null = null;
    public showModal: boolean = false;
    public showVideoPlayer: boolean = false;

    public mounted() {
        this.$emit('refresh-reports');
    }

    public get paginationDescription(): string {
        const start = (this.reports.length < 1)
            ? 0
            : ((this.currentPage - 1) * this.pageSize) + 1;

        const end = start + this.pageSize > this.total
            ? this.total
            : start + this.pageSize;

        return `Showing ${start.toLocaleString()} - ${end.toLocaleString()} of ${this.total.toLocaleString()}`;
    }

    public async handleDeleteConfirm(): Promise<void> {
        if (this.selectedReport != null) {
            const reportId = this.selectedReport.id as number;
            await reportApi.deleteByIdAsync(reportId);

            this.selectedReport = null;
            this.showModal = false;

            this.$emit('report-deleted');
        }
    }

    public handleDeleteCancel(): void {
        this.selectedReport = null;
        this.showModal = false;
    }

    public showDeleteReport(report: ReportDetails): void {
        this.selectedReport = report;
        this.showModal = true;
    }

    private openVideoPlayer() {
        this.showVideoPlayer = true;
    }
    private closeVideoPlayer() {
        this.showVideoPlayer = false;
    }
}
